import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Thanks for shopping (1).png")